// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__HYRNU","option":"SuperSelect_option__tLQ8p"};